import { render, staticRenderFns } from "./ControlPanelConfiguration.vue?vue&type=template&id=691dd4d8&scoped=true&"
import script from "./ControlPanelConfiguration.vue?vue&type=script&lang=js&"
export * from "./ControlPanelConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691dd4d8",
  null
  
)

export default component.exports